/**
 * Constantes de rotas de navegação
 *
 * Define todas as rotas usadas no sistema.
 * Mantenha organizado por módulo/feature.
 */

// ============================================
// Core Routes
// ============================================
export const HOME_ROUTE = '/home'
export const LOGIN_ROUTE = '/login'

// ============================================
// Security Routes
// ============================================
export const SEGURANCA_ROUTE = '/seguranca'
export const USUARIOS_ROUTE = '/seguranca/usuarios'
export const PERFIS_ROUTE = '/seguranca/perfis'
export const GRUPOS_ROUTE = '/seguranca/grupos'
export const RECURSOS_ROUTE = '/seguranca/recursos'
export const API_TOKENS_ROUTE = '/seguranca/api-tokens'

// ============================================
// RouteX.dev Routes
// ============================================
export const CLIENTS_ROUTE = '/clients'
export const JOBS_ROUTE = '/jobs'
export const PLAYGROUND_ROUTE = '/playground'
